import axios from 'axios'

const service = axios.create({
  baseURL: '/api',
  timeout: 120000 // 增加到120秒，支持OCR识别耗时操作
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('sign_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 401) {
      // 登录接口自身的 401（授权 code 无效/用户未维护）由页面守卫处理，不触发全局过期
      const isLoginApi = response.config.url && response.config.url.indexOf('/oauth/') > -1
      if (!isLoginApi) {
        // 会话过期：清 token 后整页刷新，由路由守卫按渠道重新分流登录
        localStorage.removeItem('sign_token')
        window.location.reload()
      }
      return Promise.reject(new Error('认证失败或登录已过期'))
    }
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
